module.exports = __webpack_public_path__ + "cb39e2d2469b2c69b96f2b99b21cab2b.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/colossal_clashes-872.webp.png
// module id = 234
// module chunks = 0